import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationMembersPage } from "~/pages/settings/organisations/organisation/members/organisation-members-page";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/members",
)({
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.members") }] }),
  component: OrganisationMembersPage,
});
